const SESSION_ID_KEY = "redisku.sessionId";

/**
 * Returns a stable per-tab session ID.
 * Uses sessionStorage so each browser tab gets its own ID,
 * but the same tab retains its ID across page refreshes.
 */
export function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}
